import { compose } from 'recompose';
import PipelineStatusItem from './pipelineStatusItem';

const enhancer = compose();

export default enhancer(PipelineStatusItem);
